import React from 'react';
import { useTranslation } from 'react-i18next';
import env from '../../../Env';

import './MainSectionStreamTextButton.scss';
import useProject from '../../../hooks/useProject';

type MainSectionStreamTextButtonProps = {
  streamTextEventName?: string | undefined;
};

const MainSectionStreamTextButton = (props: MainSectionStreamTextButtonProps) => {
  const { t } = useTranslation();
  const { project } = useProject();

  const getTextPlayerUrl = () => {
    return `/text-player.html?token=${project?.stream?.textPlayerToken}`;
  };

  if (!props.streamTextEventName || !env.streamTextPlayerUrl) {
    return null;
  }

  return (
    <div className="streamtext-caption-button">
      <a
        className="btn btn-primary btn-primary--pink"
        href={getTextPlayerUrl()}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('project-user.captioner.streamtext-button')}
      </a>
    </div>
  );
};

export default MainSectionStreamTextButton;
